import BlogDetailHead from "components/BlogDetail/components/BlogDetailHead";
import React, { useRef } from "react";
import MoreBlogs from "components/BlogDetail/components/MoreBlogs";
import "./style.scss";
import Breadcrumb from "components/BaseWidgets/Breadcrumb";
import { useNavigate, useParams } from "react-router-dom";
import { usesuccessstorydetailed } from "hooks/api/useBlogs";
import DOMPurify from "dompurify";

function SuccessStoryDetail() {
  const navigate = useNavigate();
  const { id } = useParams();
const descRef = useRef(null);
  const { data: story, isLoading: storyLoading } = usesuccessstorydetailed({
    id,
  });
  const successStory = story?.success_story || {};

  const title = successStory.title || "";
  const head = successStory.head || "";
  const body = successStory.body || "";
  const createdAt = successStory.created_at
    ? new Date(successStory.created_at).toISOString().split("T")[0]
    : "";
  const userFirstName = successStory.user?.first_name || "";
  const partnerFirstName = successStory.partner?.first_name || "";
  const bannerImage =
    successStory?.images?.[0]?.image ||
    successStory.partner?.profile_image ||
    successStory.user?.profile_image ||
    "https://via.placeholder.com/600x400";
  const shareurl =
    successStory.share_url || "https://www./profile/3SFYVmsYTIDUfnIs";

  const paragraphs = body.split(/\n\s*\n/);

    const handleLinkClick = (e) => {
    const target = e.target.closest("a");
    if (target) {
      e.preventDefault();
      e.stopPropagation();
      const url = target.getAttribute("href");
      if (url) {
        window.open(
          /^https?:\/\//i.test(url) ? url : `https://${url}`,
          "_blank",
          "noopener,noreferrer"
        );
      }
    }
  };

  return (
    <div className="container success-detail-container">
      <div className="success-breadcrumbs">
        <Breadcrumb
          items={[
            {
              title: (
                <span
                  className="breadcrumb-first"
                  onClick={() => navigate("/success-stories")}
                >
                  Success stories
                </span>
              ),
            },
            {
              title: <span className="breadcrumb-second">{title}</span>,
            },
          ]}
        />
      </div>
      <BlogDetailHead
        blogTitle={head}
        bannerImage={bannerImage}
        quotedName={userFirstName + " & " + partnerFirstName}
        quotedTime={createdAt}
        shareurl={shareurl}
        isSuccess={true}
      />
      <div className="description-area">
        <div
          ref={descRef}
          className={`blog-desc`}
          onClick={handleLinkClick}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(paragraphs || "", {
              ADD_ATTR: ["target", "rel"],
            }),
          }}
        />
        <div className="more-blogs-sidebar">
          <MoreBlogs isSuccessView={true} currentStoryId={id} />
        </div>
      </div>
    </div>
  );
}
export default SuccessStoryDetail;
